import { SimulationStateNameTO } from '@control-center/control-center-client-public-domain-simulation-ts';

import './_SimulationStateBadge.scss';

type SimulationState = (typeof SimulationStateNameTO)[keyof typeof SimulationStateNameTO];

interface Props {
    state: SimulationState;
}

const getModifier = (state: SimulationState): string => {
    switch (state) {
        case SimulationStateNameTO.Starting:
        case SimulationStateNameTO.Running:
        case SimulationStateNameTO.Completing:
            return 'progressing';
        case SimulationStateNameTO.Overridden:
            return 'danger';
        case SimulationStateNameTO.Completed:
            return 'complete';
        default:
            return 'neutral';
    }
};

const SimulationStateBadge = ({ state }: Props) => (
    <div
        className={`SimulationStateBadge SimulationStateBadge--${getModifier(state)}`}
        data-testid='domain-sim-state-badge'
    >
        {state}
    </div>
);

export default SimulationStateBadge;
